export default "<p>owner-medical-consultation-other-income-table works!</p>\n"